/** @file This file implements utility functions for numbers. */
import { Maybe } from '@codegrade/maybe';
/**
 * Try to parse an integer from a string.
 *
 * @param num The string representing the number.
 * @returns The parsed integer, or `Nothing` if the value does not represent an
 * integer.
 */
export function maybeParseInt(num) {
    // We need to parse with both parseInt and Number because:
    // * parseInt('5a') -> 5  while  Number('5a') -> NaN
    // * parseInt('') -> NaN  while  Number('') -> 0
    return Maybe.of(parseInt(num, 10)).filter(x => x === Number(num));
}
/**
 * Clamp number `num` between, `min` and `max`.
 *
 * @param root0 The IClamp data containing min max and num.
 * @returns The `num`ber that will either clamped between `min` and `max`.
 */
export function clamp({ num, min, max }) {
    return Math.min(max, Math.max(num, min));
}
/**
 * Clamp the number `num` as a pecentage, so between 0 and 100 inclusive.
 *
 * Note that we also round the number, because we only support whole percents.
 *
 * @param num The number to be clamped.
 * @returns The clamped between 0 and 100.
 */
export function clampWholePercentage(num) {
    return clamp({ num: Math.round(num), min: 0, max: 100 });
}
